import * as React from 'react';
import TranslateNew from '@translate/TranslateNew';
import cordovaContext from "src/cordovaContext";
import 'cordova-plugin-purchase';
import { getOS } from '@helpers/osDetection';
import { connect } from 'react-redux';
import * as UserActions from '@services/user/user.actions';
import { createSubscriptionStoreDiagnostic, isReportableSubscriptionStoreError } from './subscriptionDiagnostics';

const tn: TranslateNew = TranslateNew.getInstance();

// PayWall remounts this connector every time the websocket reconnects, but the purchase plugin's
// store is a singleton: registering again stacks duplicate store handlers, and a second
// store.initialize() resolves at once without products. So the store is loaded once per app session.
let storeLoadStarted = false;
// Kept current on every mount, so purchases belong to whoever is logged in now.
let storeAccountId = 0;
const reportedDiagnostics:{[key:string]:boolean} = {};

interface IProps {
  accountId: number;
  reportProblem: (msg:string) => void;
}

class SubscriptionConnector extends React.Component<IProps> {

  constructor(props: IProps) {
    super(props);
  }

  public componentDidMount() {
    storeAccountId = this.props.accountId;
    const isCordovaApp = this.context;
    if (isCordovaApp) {
      document.addEventListener("deviceready", () => { 
        this.loadStore();
      }, false);
    } else {
      this.loadStore();
    }
  }

  public componentDidUpdate() {
    storeAccountId = this.props.accountId;
  }

  public render() {
    return (<div id="subscriptionconnector"/>)
  }

  public loadStore() {

    if (storeLoadStarted) {
      return;
    }
    storeLoadStarted = true; // Lock it immediately

    const {store, ProductType, Platform} = CdvPurchase;
    const os = getOS();
    const isCordovaApp = this.context;

    if (store === undefined || store.isReady === true) {
      return;
    }

    
    const products:CdvPurchase.IRegisterProduct[] = [];
    let platform:CdvPurchase.Platform|undefined;

    if (os === 'ANDROID' && isCordovaApp) {
      platform = Platform.GOOGLE_PLAY;
      products.push({id: 'monthly2',platform,type: ProductType.PAID_SUBSCRIPTION,});
      products.push({id: 'monthly4',platform,type: ProductType.PAID_SUBSCRIPTION,});
    } else if (os === 'IOS' && isCordovaApp) {
      platform = Platform.APPLE_APPSTORE;
      products.push({id: 'monthly2',platform,type: ProductType.PAID_SUBSCRIPTION,});
      products.push({id: 'monthly4',platform,type: ProductType.PAID_SUBSCRIPTION,});
    } else {
      console.log("No products to register");
    }

    store.applicationUsername = () => {
      return ("" + storeAccountId); // a string
    };

    store.register(products);

    store.error((error:CdvPurchase.IError) => {
      this.reportDiagnostic("store-error", platform || error.platform || undefined, error);
    });
    
    store.when().productUpdated((product:CdvPurchase.Product) => console.log("product "+product.id+": updated"));

    store.when().approved((transaction:CdvPurchase.Transaction) => {
      console.log("transaction approved");
      transaction.verify().catch(err => {
        console.error("Verification failed: ", err);
      });
    });

    store.when().verified((receipt:CdvPurchase.VerifiedReceipt) => {
      console.log("receipt verified");
      receipt.finish().catch(err => {
          console.error("finish failed: ", err);
      });
    });

    store.validator = 'https://validator.fovea.cc/v1/validate?appName=varannanvecka.app&apiKey=78b3264f-bddb-4d54-8a19-680a6a9307fd';
    store.initialize().then((errors:CdvPurchase.IError[]) => {
      if (errors && errors.length > 0) {
        errors.forEach((error:CdvPurchase.IError) => {
          this.reportDiagnostic("initialize-error", platform || error.platform || undefined, error);
        });
      } else if (platform && !store.get("monthly2", platform)) {
        this.reportDiagnostic("product-missing-after-initialize", platform);
      }
    }).catch((error:any) => {
      this.reportDiagnostic("initialize-rejected", platform, error);
    });
  }

  private reportDiagnostic(stage:string, platform:CdvPurchase.Platform|undefined, error?:any) {
    if (!isReportableSubscriptionStoreError(error)) {
      return;
    }

    const diagnostic = createSubscriptionStoreDiagnostic(stage, "monthly2", platform, error, {
      accountId: storeAccountId,
    });

    // A failed App Store purchase reaches store.error() twice with the same StoreKit error,
    // first from the transaction and then from store.order(), so it is sent once.
    if (reportedDiagnostics[diagnostic]) {
      return;
    }

    reportedDiagnostics[diagnostic] = true;
    this.props.reportProblem(diagnostic);
  }
}

SubscriptionConnector.contextType = cordovaContext;

const mapDispatchToProps = {
  reportProblem: UserActions.reportProblem,
};

export default connect(null, mapDispatchToProps)(SubscriptionConnector);



// WEBPACK FOOTER //
// ./src/components/subscription/SubscriptionConnector.tsx